"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNITARY_VARIATION_NAME = void 0;
exports.UNITARY_VARIATION_NAME = 'Unitaire';
